

























import { Component, Vue, Prop } from "vue-property-decorator";
import ActivityLabel from "@/components/common/edit/ActivityLabel.vue";
import { Getter, Action } from "vuex-class";

@Component({
  components: {
    "activity-label": ActivityLabel
  }
})
export default class ActivityInstAddress extends Vue {

  @Getter("instAddress") getInstAddress!: string;
  @Getter("section")
  section!: string;

  @Action("changeInstAddress")
  changeInstAddress!: Function;

  get instAddress(): string {
    return this.getInstAddress;
  }

  set instAddress(val: string) {
    this.changeInstAddress(val);
  }
}
